import axios from 'axios';

export const API_BASE_URL = 'https://api-pps-dev.data.siemens-energy.cloud';

export interface Part {
  is_header: boolean;
  Description: string;
  id: string;
  partName: string;
  materialNumber: string;
  bom: string;
  category: string;
}

export interface SparePartsResponse {
  serial: string;
  is_promoted: boolean;
  node_count: number;
  bom_count: number;
  parts: Part[];
}

export class SparePartsApiError extends Error {
  constructor(message: string, public statusCode?: number) {
    super(message);
    this.name = 'SparePartsApiError';
  }
}

const createAuthHeaders = (accessToken: string) => ({
  'Authorization': `Bearer ${accessToken}`,
  'Content-Type': 'application/json',
});

export const sparePartsApi = {
  /**
   * Fetch spare parts for a given turbine serial number
   */
  async fetchSparePartsBySerial(serial: string, accessToken: string): Promise<SparePartsResponse> {
    try {
      const response = await axios.get<SparePartsResponse>(
        `${API_BASE_URL}/spare-parts/${serial}`,
        {
          headers: createAuthHeaders(accessToken),
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new SparePartsApiError(
          error.response?.data?.message || error.response?.data?.error_description || error.message,
          error.response?.status
        );
      }
      throw error;
    }
  },

  /**
   * Download spare parts as Excel file
   */
  async downloadSparePartsExcel(serial: string, accessToken: string): Promise<Blob> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/spare-parts/${serial}/export`,
        {
          headers: createAuthHeaders(accessToken),
          responseType: 'blob',
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new SparePartsApiError(
          error.response?.data?.message || error.message,
          error.response?.status
        );
      }
      throw error;
    }
  },

  /**
   * Health check endpoint
   */
  async checkHealth(): Promise<{ status: string }> {
    try {
      const response = await axios.get<{ status: string }>(
        `${API_BASE_URL}/health`
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new SparePartsApiError(
          error.response?.data?.message || error.message,
          error.response?.status
        );
      }
      throw error;
    }
  },
};
